/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Forward15Line = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 2a10 10 0 1 0 10 10h-2a8 8 0 1 1-1.38-4.5H16v1h-4v4.25h2.88a.63.63 0 1 1 0 1.25H12v1.5h2.88a2.13 2.13 0 0 0 0-4.25H13.5V10h3.25v-.5H22v-6h-2V6a10 10 0 0 0-8-4M8.5 8.5H10v7H8.5z" />
  </Icon>
);
